// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

export default class RemoteModal {
  constructor(url, closeAfterResolve) {
    if (closeAfterResolve === undefined) {
      this.closeAfterResolve = true
    } else {
      this.closeAfterResolve = closeAfterResolve
    }

    this.url = url
    this.queryParams = {}
  }

  open() {
    return new Promise((resolve) => {
      const url = new up.Params(this.queryParams).toURL(this.url)
      return up.layer.open({ url, mode: 'modal', history: false, target: '.modal' })
        .then(() => {
          const modal = document.querySelector('up-modal')

          this.onOpened(modal)

          document.addEventListener('remote:modal:return', () => {
            resolve(this.returnValue)
            this.returnValue = undefined
          }, { once: true })
        })
    })
  }

  returnWithValue(value) {
    this.returnValue = value
    up.emit('remote:modal:return')

    if (this.closeAfterResolve) {
      up.layer.dismiss()
    }
  }

  onOpened(modal) {}
}
